export const debounce = <F extends (...args: any[]) => void>(callback: F, delay: number) => {
  let timeoutId: number | undefined;
  return (...args: Parameters<F>) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => { callback(...args); }, delay);
  };
};